var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanelSwitchOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .svg-switch-open{fill:#14355b}\n    ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n        Open Panel\n    ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-switch-open",
    d: "M12.5,1.9c0-0.3,0.1-0.5,0.3-0.7c0.4-0.4,1.1-0.4,1.5,0l13.5,13.1c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1.1,0.4-1.5,0L12.8,2.6C12.6,2.4,12.5,2.1,12.5,1.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-switch-open",
    d: "M12.5,28.1c0-0.3,0.1-0.5,0.3-0.7l13.5-13.1c0.4-0.4,1.1-0.4,1.5,0c0.4,0.4,0.4,1,0,1.4L14.2,28.8c-0.4,0.4-1.1,0.4-1.5,0C12.6,28.6,12.5,28.4,12.5,28.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-switch-open",
    d: "M2,1.9c0-0.3,0.1-0.5,0.3-0.7c0.4-0.4,1.1-0.4,1.5,0l13.5,13.1c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1.1,0.4-1.5,0L2.3,2.6C2.1,2.4,2,2.1,2,1.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-switch-open",
    d: "M2,28.1c0-0.3,0.1-0.5,0.3-0.7l13.5-13.1c0.4-0.4,1.1-0.4,1.5,0c0.4,0.4,0.4,1,0,1.4L3.8,28.8c-0.4,0.4-1.1,0.4-1.5,0C2.1,28.6,2,28.4,2,28.1z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelSwitchOpen);
export default __webpack_public_path__ + "static/media/panel-switch-open.42bbf2e1.svg";
export { ForwardRef as ReactComponent };